/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardSkipperDialogController', BoardSkipperDialogController);

    BoardSkipperDialogController.$inject = ['skipperLevels', '$timeout', '$scope', '$sce', '$stateParams', '$uibModalInstance', 'entity', 'Skipper', 'Principal'];

    function BoardSkipperDialogController (skipperLevels, $timeout, $scope, $sce, $stateParams, $uibModalInstance, entity, Skipper, Principal) {
        var vm = this;

        vm.skipper = entity;
        vm.skipperLevels = skipperLevels.data;
        vm.skipperLevelsSelected = [];
        for (var index = 0; index < vm.skipperLevels.length; index++) {
            vm.skipperLevelsSelected.push(vm.skipper.skipperLevels.includes(vm.skipperLevels[index]));
        }

        vm.isSkipperManager = false;
        Principal.hasAuthority('ROLE_SKIPPER_MANAGER').then(function (result) {
            vm.isSkipperManager = result;
        });

        vm.clear = clear;
        vm.save = save;

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.skipper.skipperLevels = [];
            for (var index = 0; index < vm.skipperLevels.length; index++) {
                if (vm.skipperLevelsSelected[index]) {
                    vm.skipper.skipperLevels.push(vm.skipperLevels[index]);
                }
            }
            Skipper.update(vm.skipper, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:skipperUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };
    }
})();
